<template>
	<div class="floatButton">
		<div class="float-button">
			<div class="item" v-show="current!=0" @click="goBack()">
				返回<br>
				上一页
			</div>
			<div class="item" @click="backTop()">
				<i class="el-icon-arrow-up"></i>
				<div>顶部</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'floatButton',
		props: ['current'],
		data() {
			return {};
		},
		methods: {
			goBack(){
				this.$router.back()
			},
			backTop(){
				window.scrollTo(0, 0);
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.float-button {
		position: fixed;
		right: 30px;
		top: 80%;
		width: 50px;
		border-radius: @vue-border-radius-base;
		box-shadow: 0px 0px 10px @vue-border-color;
		overflow: hidden;
	
		.item {
			width: 100%;
			height: 50px;
			text-align: center;
			display: flex;
			align-items: center;
			justify-content: center;
			align-content: center;
			font-size: @vue-font-size-min;
			cursor: pointer;
		}
		
		.item:first-child{
			background: @vue-bg-color-red;
			opacity: 0.7;
			color: @vue-text-color-inverse;
			border-bottom: 1px solid @vue-border-color;
			box-sizing: border-box;
		}
	
		.item:last-child {
			background: @vue-bg-color;
			flex-wrap: wrap;
	
			div {
				width: 100%;
			}
		}
	}
</style>
